import { createBrowserHistory } from "history";
import { RouterStore, syncHistoryWithStore } from "mobx-react-router";
import { config } from "config";

const defaultRouterStore = new RouterStore();

export const history = syncHistoryWithStore(createBrowserHistory({ basename: config.network.appBaseUrl }), defaultRouterStore);

// https://github.com/ReactTraining/react-router/issues/2144#issuecomment-150939358
// history.listen((location: any) => {

//     // Use setTimeout to make sure this runs after React Router's own listener.
//     setTimeout(() => {
//         window.scrollTo(0, 0);
//     });
// });

export default defaultRouterStore;



// WEBPACK FOOTER //
// ./src/stores/RouterStore.ts